import { AppBar, Box } from "@mui/material";
import { KeyDriveh4Header } from "../KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveCaption } from "../KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeyDrivePrimaryButton } from "../KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { useTranslation } from "react-i18next";
import moment from "moment";

interface IFreeSoftwareAlert {
    isCollapsed: boolean;
    nameOrg: string;
}

export default function CancelDueAlert({
    isCollapsed,
    nameOrg
}: IFreeSoftwareAlert) {

    const navigate = useNavigate();
    const profile = useProfile();
    const { t } = useTranslation();
    
    function alertTextHandler() {
        if (!profile?.signture?.isOriginSignture) {
            return t("CancelDueAlert.CheckWithAdmin");
        } 

        return t("CancelDueAlert.CanCancelRequest");
    }

    return (
        <AppBar
            sx={{
                width: `${isCollapsed ? "calc(100% - 66px)" : "calc(100% - 220px)"}`,
                height: "50px",
                marginTop: "66px",
                backgroundColor: "#22638D",
                padding: "4px",
                zIndex: "-1 !important"
            }}
        >
            <Box    
                width="100%"
                height="100%"
                display="flex"
                justifyContent="space-between"
            >
                <Box>
                    <KeyDriveh4Header 
                        text={`${t("CancelDueAlert.SubscriptionScheduledForCancellation")} ${moment(profile?.signtureInformation?.cancelAt).format("DD/MM/YYYY")}`}
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                    <KeyDriveCaption 
                        text={alertTextHandler()}
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                </Box>
                    { profile?.signture?.isOriginSignture && (
                        <KeyDrivePrimaryButton
                            endIcon={<ArrowForwardIos />}
                            width="250px"
                            TextComponent={KeyDriveCaption}
                            TextComponentProps={{
                                color: "#E8EFF3",
                                needBold: false,
                                needEllipses: false,
                                text: t("CancelDueAlert.AccessAccountAndSubscription")
                            }}
                            needFullWidth={false}
                            backgroundColor="#F58601"
                            disabled={nameOrg == undefined}
                            onClick={()=> {
                                navigate(`${nameOrg}/adminConsole/accountAndSubscription`);
                            }}
                        />
                    ) }
            </Box>
        </AppBar>
    )
}